import styled from 'styled-components';

export const SelectContainer = styled.div`
  width: 100%;
  min-height: 40px;
  margin-top: 10px;
  margin-bottom: 10px;
  position: relative;
  font-size: 14px;
  cursor: pointer;
`;

export const SelectedValueContainer = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #fff;
  justify-content: space-between;

  &:hover {
    border-color: #007bff;
  }
`;

export const SelectedValue = styled.p`
  max-width: 80%;
  text-align: start;
  font-size: 14px;
  color: #919eab;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ArrowIcons = styled.div`
display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background-color: ${({ theme }) => theme.colors.surface.base};

  &:hover {
    cursor: pointer;
  }
`;

export const Dropdown = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 160px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1;
  padding: 0;
  margin: 0;
  font-size: 12px;

  &::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
`;

export const Option = styled.li`
  padding: 8px 12px;
  font-size: 12px;
  color: #919eab;
  cursor: pointer;
  background-color: #fff;
  
  &:hover {
    background-color: #f0f0f0;
  }

  &:active {
    background-color: #ddd;
  }
`;
